import React, { Component, useState, useEffect } from "react";
import Container from '@material-ui/core/Container';
import Grid from '@material-ui/core/Grid'
import PropTypes from 'prop-types';
import AppBar from '@material-ui/core/AppBar';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';
import InfoOutlinedIcon from '@material-ui/icons/InfoOutlined'; 

import RadioButtonUncheckedIcon from '@material-ui/icons/RadioButtonUnchecked';
import CompareArrowsIcon from '@material-ui/icons/CompareArrows';
import Menu from '../Components/Menuv2/menu'
import Footer from '../Components/Footerv2/footer'
import Tokens from './tabs/tokens'
import Pairs from './tabs/pairs'

import './browser.css'

import srcimg from '../img/brow/pancakeswaplogo.png'
import cakeimg from '../img/brow/pacnckagebackgroundlight.png'



/*******************
*
* Functions for tabs
*
********************/
function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box p={3}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}
TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};
function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}
/* end */
const Browser = () => {
  const [tabVal, settabVal] = useState(0)

  /*******************
  *
  control handle for tabs
  *
  ********************/
  const tabsChange = (event, newValue) => {
    settabVal(newValue);
  };



  return (
    <div className="pcc---slider" style={{backgroundColor:'#f6f6f6'}}>
      <Menu />
        <Container maxWidth="lg">
            <Grid
                container
                justify="flex-start"
                alignItems="flex-start"            >
                <Grid 
                    container 
                    justify="flex-start" 
                    alignItems="flex-start"
                    direction="column"
                    className="my-md-5 position-relative"
                    xs={12}
                >
                  <h5 className="text-left">Exchange</h5>
                  <h2>
                    <img src={srcimg} style={{width: 32, height: 'auto', marginRight: 8}} />
                    PancakeswapV2
                  </h2>
                  <p className="mt-2 py-1 px-2" style={{marginLeft:'40px', backgroundColor:'#f9d8a2',fontSize: 12,color:'#fdb134'}}>
                    <InfoOutlinedIcon style={{fontSize: 18,}} /> The pancakeswap explorer is out of sync
                  </p>
                  <img src={cakeimg} className="pcc---browser-mainIcon" />
                </Grid>
                <Grid 
                    xs={12}
                    className="text-left pb-5"
                >
                  <AppBar position="static" className=" pc---border-bottom pc---border-bottomV2">
                    <Tabs value={tabVal} onChange={tabsChange} aria-label="simple tabs example" className="pc---tokenTab pc---tokenTabV2">
                      <Tab label="Tokens" icon={<RadioButtonUncheckedIcon />} {...a11yProps(0)} ></Tab>
                      <Tab label="Pairs" icon={<CompareArrowsIcon />} {...a11yProps(1)} />
                    </Tabs>
                  </AppBar>
                  <TabPanel value={tabVal} index={0} className="pc---inner_tabs">
                    <Tokens />
                  </TabPanel>
                  <TabPanel value={tabVal} index={1}>
                    <Pairs />
                  </TabPanel>
                </Grid>
            </Grid>
        </Container>
      <Footer />
    </div> 
  );
}

export default Browser;
